import React, { useEffect, useState } from "react";
import { Loader2, PenLine, Save } from "lucide-react";
import { api, errorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";

export function SignatureEditor() {
  const { t } = useI18n();
  const [sig, setSig] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/mail/signature").then((r) => setSig(r.data.signature)); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/mail/signature", { signature: sig }); setSig(data.signature); toast.success(t("Signature saved")); }
    catch (e) { toast.error(errorDetail(e)); } finally { setBusy(false); }
  };
  if (sig === null) return <div className="h-32 rounded-xl bg-muted shimmer" />;
  return (
    <div className="card-surface p-4 mt-4 space-y-2" data-testid="signature-editor">
      <div className="flex items-center gap-1.5 text-sm font-semibold"><PenLine className="w-4 h-4 text-primary" />{t("Email signature")}</div>
      <p className="text-xs text-muted-foreground">{t("Added automatically at the end of every email and reply you send from TOPTALENT.")}</p>
      <Textarea rows={5} maxLength={2000} value={sig} onChange={(e) => setSig(e.target.value)} placeholder={t("e.g. Jane Smith\nSenior Recruiter · Acme\n+33 6 00 00 00 00")} data-testid="signature-input" />
      <div className="flex justify-end"><Button size="sm" disabled={busy} onClick={save} data-testid="signature-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}{t("Save")}</Button></div>
    </div>
  );
}
